<template>
    <div class="tg-page-root flex min-h-screen flex-col bg-gray-50 dark:bg-gray-950">
        <div class="aspect-ratio-box mt-7 cursor-pointer mx-auto">
            <img :src="card_background" />
            <div class="avatar-with-text">
                <div class="flex items-center justify-between">
                    <div class="text-white">
                        <div class="font-thin">{{ $t('Balance') }}</div>
                        <div class="mt-1 font-bold text-2xl">$ {{ myScore.toFixed(2) }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-grow rounded-t-3xl bg-white dark:bg-gray-900 overflow-auto p-5 border-t border-gray-100 dark:border-gray-800">
            <div class="flex justify-between items-center">
                <div class="font-semibold min-w-0">
                    <div class="text-brand dark:text-violet-300">{{ $t('SendInvite') }}</div>
                    <div class="mt-1 pr-3 text-gray-900 dark:text-gray-100">{{ $t('InviteMsg') }}</div>
                </div>
                <img :src="recommendIcon" class="w-[40px] cursor-pointer" @click="goInvite">
            </div>
            <div class="mt-3 py-2 text-gray-900 dark:text-gray-100 font-medium border-b border-gray-100 dark:border-gray-800 w-full">{{ $t('Balance_Records') }}</div>
            <div class="py-3 flex items-center justify-between" v-for="(invitation, index) in invitation_list"
                :key="index">
                <div>
                    <div class="text-gray-900 dark:text-gray-100 font-semibold">
                        {{ invitation.type === 0 ? $t('Referral_Bonus') :
                (invitation.type === 2 ? $t('Withdraw ') : $t('Welcome_Bonus')) }}
                    </div>

                    <div class="text-slate-500 dark:text-gray-400 text-sm">{{ convertToLocalTime(invitation.PaymentTime) }}</div>
                </div>
                <div class="text-lg font-semibold"
                    :class="{ 'text-brand dark:text-violet-300': invitation.type !== 2, 'text-red-500 dark:text-red-400': invitation.type === 2 }">
                    {{ invitation.type === 2 ? '- US$' + invitation.amount.toFixed(2) : '+ US$' + (invitation.type === 0
                ? '5.00' :
                '4.00') }}
                </div>
            </div>
            <el-empty class="invitation-empty" :description="$t('No_Data')" v-if="invitation_list.length == 0" />
        </div>
    </div>

</template>
<script setup>
import { inject, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router'
import { showAppNotification } from '@/utils/appNotification'
import { writeAppClipboard } from '@/utils/appClipboard'
import { getInvitationCode } from '@/utils/invitationCodeStorage'
import { buildReferralDeepLink } from '@/utils/referralDeepLink'
import logger from '@/utils/logger'
import { useTelegramWebApp } from '@/composables/useTelegramWebApp'

const router = useRouter()
const { shareViaTelegram } = useTelegramWebApp()

const { t } = useI18n();
const api = inject('api')
const timeService = inject('timeService');
const card_background = require('@/assets/img/card-bg-1.png')
const recommendIcon = require('@/assets/icons/recommend.png')
const myScore = ref(0)
const invitation_list = ref([])

onMounted(() => {
    getScoreOrder()
    getInvitationScore()
})

const getScoreOrder = async () => {
    const response = await api.invitation.getScoreOrder(localStorage.getItem('telegramUserId'))
    invitation_list.value = response.data
}

const getInvitationScore = async () => {
    const response = await api.invitation.getInvitationScore(localStorage.getItem('telegramUserId'))
    myScore.value = response.data.invitation_score
};

const goInvite = async () => {
    const title = t('Share_Title');
    const code = await getInvitationCode('');
    const url = buildReferralDeepLink(code);
    
    const text = t('Share_Content', { code, url });

    if (shareViaTelegram({ url, text })) {
        return
    }

    try {
        await navigator.share({
            title,
            text,
            url
        });
    } catch (error) {
        window.focus();
        logger.debug('Copy text:', text);
        const copied = await writeAppClipboard(text)
        if (copied) {
            showAppNotification({ message: t('Copied_Successfully'), type: 'success', position: 'bottom-right', duration: 2000 });
        }
    }
}
const convertToLocalTime = timeService.convertToLocalTime
</script>

<style scoped>
.aspect-ratio-box {
    position: relative;
    width: 90%;
}

.aspect-ratio-box .avatar-with-text {
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 1.3rem;
    padding-left: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 10;
}


.aspect-ratio-box::before {
    content: '';
    display: block;
    padding-top: calc(225 / 585 * 100%);
}

.aspect-ratio-box img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
}

.flex-grow {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.rounded-t-3xl.bg-white.overflow-auto {
    overflow-y: auto;
}

:global(html.dark .invitation-empty .el-empty__description p) {
    color: #9ca3af;
}
</style>
